//   const USAComma = useNumberFormatter();
// formatNumber(lead?.QuotedValue);


export default function CommaConvert() {
  const countryCode = String(localStorage.getItem("countrycode") || "").trim();
  const region = String(localStorage.getItem("region") || "")
    .trim()
    .toUpperCase();
  const isUsLocale = countryCode === "+1" || countryCode === "1" || region === "US" || region === "USA";
  const isInLocale = countryCode === "+91" || countryCode === "91" || region === "IN" || region === "INDIA";

  return (num) => {
    if (num === undefined || num === null) return "";
    const value = Number(num);
    if (isNaN(value)) return "";

    if (isUsLocale) {
      return Math.round(value).toLocaleString("en-US");
    }

    if (isInLocale) {
      return Math.round(value).toLocaleString("en-IN");
    }

    return Math.round(value).toLocaleString("en-US");
  };
}